// ======================================================================
// File Name       : UserfrontLoginScreenContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import { Component } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { change, getFormValues, isInvalid, reduxForm } from 'redux-form';
import * as userfrontImageAction from '../../actions/UserFrontImageAction';
import DialogConfirm from '../../components/DialogConfirm';
import LoginScreenSetting from '../../components/userfront/LoginScreenSetting';
import ThumbNail from '../../components/userfront/ThumbNail';
import { HIDE_MESSAGE } from '../../constants/actionTypes/message';
import { INITIAL_IMAGE } from '../../constants/InitialImageConstants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { LOGIN_SCREEN_KEY_LIST, USERFRONT_IMAGE_SCREEN_TYPE } from '../../constants/UserfrontImageConstants';
import { downLoadFile } from '../../utils/ApiUtils';
import { hasProperty } from '../../utils/index';
import RenderField from '../../utils/ReduxFormUtils';

class UserfrontLoginScreenContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialData: {
        imageUpdateType: INITIAL_IMAGE.IMAGE_SYSTEMS,
        imageType: null,
        imageFileUpload: null,
        thumbnailUrl: '',
      },
      initialImageList: [],
      initialImageObject: null,
      okBtnClick: false,
      saveDisplayBtnClick: false,
    };
    this.handleImageFileChange = this.handleImageFileChange.bind(this);
    this.getInitialImage = this.getInitialImage.bind(this);
    this.onOk = this.onOk.bind(this);
    this.createParamUpload = this.createParamUpload.bind(this);
    this.handleChangeOption = this.handleChangeOption.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(this);
    this.onConfirmDialogOk = this.onConfirmDialogOk.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }

  componentDidMount() {
    this.getInitialImage();
  }

  componentWillUnmount() {
    this.props.dispatch(userfrontImageAction.resetInitState());
  }

  getInitialImage() {
    const paramGetInitialImage = {};
    this.props.dispatch(userfrontImageAction.getInitialImage(paramGetInitialImage));
  }

  handleImageFileChange(event) {
    if (event.target.files.length !== 0) {
      const nameTarget = event.target.name;
      const { imageObject, dispatch } = this.props;
      const reader = new FileReader();
      const file = event.target.files[0];
      if (imageObject && Object.keys(imageObject).length) {
        const place = nameTarget.indexOf('.');
        const nameKey = nameTarget.slice(0, place);
        if (hasProperty(imageObject, nameKey)) {
          reader.onloadend = () => {
            const newFormValue = { ...imageObject[nameKey] };
            newFormValue.imageFileUpload = file;
            newFormValue.thumbnailUrlFileLoad = reader.result;
            newFormValue.changed = true;
            const id = `${nameKey}.imageFileUpload`;
            $(`#${id}`).val('');
            dispatch(change('userfrontImageLogin', nameKey, newFormValue));
            dispatch(userfrontImageAction.changeImageFile(nameKey, newFormValue));
          };
          reader.readAsDataURL(file);
        }
      }
    }
  }

  onOk() {
    const { auth, imageObject } = this.props;
    const listParams = [];
    this.setState({ showExportModal: false, okBtnClick: true}, () => {
      if (imageObject && Object.keys(imageObject).length) {
        Object.keys(imageObject).map((childKey) => {
          if (hasProperty(imageObject, childKey)) {
            if (imageObject[childKey] && Object.keys(imageObject[childKey]).length) {
              const param = this.createParamUpload(imageObject[childKey]);
              if (param) listParams.push(param);

              const newFormValue = { ...imageObject[childKey] };
              delete newFormValue.changed;
              this.props.dispatch(change('userfrontImageLogin', childKey, newFormValue));
            }
          }
          return null;
        });
      }
      if (listParams.length > 0) {
        this.props.dispatch(userfrontImageAction.editInitialImage(auth, listParams)).then((error) => {
          this.setState({ okBtnClick: false });
          if (!error) {
            const container = $('#sroll-container');
            if (container && container.length) {
              container.scrollTop(0);
            }
            this.getInitialImage();
            // Hide error message after uploading thumbnail successful
            this.props.dispatch({ type: HIDE_MESSAGE });
          }
        });
      }
    });
  }

  createParamUpload(obj) {
    if (!obj) return null;
    if (!obj.changed) return null;
    const param = {};
    param.userfrontImageType = obj.userfrontImageType;
    param.multilangType = obj.multilangType;
    obj.imageFileUpload && (param.uploadFile = obj.imageFileUpload);
    param.imageUpdateType = obj.imageUpdateType;
    return param;
  }

  handleChangeOption(value) {
    const { dispatch, imageObject } = this.props;
    const languageSetting = parseInt(value, 10);
    const params = {
      userfrontScreenType: USERFRONT_IMAGE_SCREEN_TYPE.LOGIN,
      languageSetting,
    };

    dispatch(change('userfrontImageLogin', 'languageSetting', languageSetting));
    if (imageObject && Object.keys(imageObject).length) {
      Object.keys(imageObject).map((childKey) => {
        if (hasProperty(imageObject, childKey)) {
          if (imageObject[childKey] && Object.keys(imageObject[childKey]).length) {
            const newFormValue = { ...imageObject[childKey] };
            delete newFormValue.changed;
            this.props.dispatch(change('userfrontImageLogin', childKey, newFormValue));
          }
        }
        return null;
      });
    }
    dispatch(userfrontImageAction.changeUserfrontImageData(params));
  }

  static getDerivedStateFromProps(nextProps) {
    const { dispatch, imageObject } = nextProps;
    if (nextProps && nextProps.formValues && Object.keys(nextProps.formValues).length) {
      LOGIN_SCREEN_KEY_LIST.map((childKey) => {
        if (nextProps.formValues[childKey] && !nextProps.formValues[childKey].dataUrl) {
          const reader = new FileReader();
          const newFormValue = { ...imageObject[childKey] };
          downLoadFile(nextProps.formValues[childKey].userfrontImageUrl).then((blob) => {
            reader.onloadend = () => {
              newFormValue.dataUrl = reader.result;
              dispatch(change('userfrontImageLogin', childKey, newFormValue));

              const params = {
                key: childKey,
                dataUrl: reader.result,
              };
              dispatch(userfrontImageAction.getImageData(params));
            };
            reader.readAsDataURL(blob);
          });
        }
      });
    }
  }

  onChangeCheckbox(event) {
    const { userfrontImageLogin } = this.props;
    if (userfrontImageLogin && Object.keys(userfrontImageLogin).length) {
      const nameTarget = event.target.name;
      const place = nameTarget.indexOf('.');
      const nameKey = nameTarget.slice(0, place);
      if (hasProperty(userfrontImageLogin.values, nameKey)) {
        const newFormValue = { ...userfrontImageLogin.values[nameKey] };
        if (event.target.checked) {
          newFormValue.changed = true;
          newFormValue.imageUpdateType = INITIAL_IMAGE.IMAGE_SYSTEMS;
        } else {
          delete newFormValue.changed;
          newFormValue.imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
        }
        newFormValue.thumbnailUrlFileLoad = '';
        newFormValue.imageFileUpload = '';

        const id = `${nameKey}imageFileUpload`;
        $(`#${id}`).val('');
        this.props.dispatch(change('userfrontImageLogin', nameKey, newFormValue));
      }
    }
  }

  openConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showExportModal: true });
  }

  /**
 * Action when click OK button in dialog from 表示設定を保存する button
 */
  onConfirmDialogOk() {
    const { formValues } = this.props;
    this.setState({ showExportModal: false, saveDisplayBtnClick: true }, () => {
      if (formValues && Object.keys(formValues).length) {
        const { loginBackgroundFlag, loginPanelLogoFlag  } = formValues;
        const params = {
          loginBackgroundFlag,
          loginPanelLogoFlag,
        };

        this.props.dispatch(userfrontImageAction.updateDisplaySetting(params)).then((error) => {
          this.setState({ saveDisplayBtnClick: false });
          if (!error) {
            this.getInitialImage();
            // Hide error message after uploading thumbnail successful
            this.props.dispatch({ type: HIDE_MESSAGE });
          }
        });
      }
    });
  }

  render() {
    const { invalid, imageObject, userfrontImageLogin, isEnableRegistBtn, isOEMUser } = this.props;

    return (
      <div>
        <Form className='form-horizontal'>
          <Col sm={12} className="padding-left-right-clear bold">
            <h3 className="margin-top-10">受講ユーザーがログインする際の画面に表示する画像を変更します。</h3>
          </Col>
          <Col sm={12} className="margin-top-20 padding-left-right-clear bold">
            <h3 className="margin-top-10">ステップ１）表示させるエリアを選ぶ</h3>
            <h3 className="margin-top-10">表示させるエリアにチェックを入れた後に、「表示設定を保存する」を押してください。</h3>
          </Col>
          <Col sm={12} className="margin-top-20">
            <LoginScreenSetting
              formValues={userfrontImageLogin}
            />
          </Col>
          <Col sm={12} className="margin-bottom-20 padding-left-right-clear">
            <Button
              variant="primary"
              className="btn-96 text-center margin-top-20"
              onClick={this.openConfirmDialog}
              disabled={this.state.saveDisplayBtnClick}
            >
              表示設定を保存する
            </Button>
          </Col>
          <Col sm={12} className="margin-top-20 padding-left-right-clear bold">
            <h3 className="margin-top-10">ステップ２）画像を登録する</h3>
            <h3 className="margin-top-10">画像は言語ごとに設定することができます。設定する言語を選んでから、各エリアに表示させる画像を設定してください。</h3>
            <h3 className="margin-top-10">ご利用できるファイル形式はpng形式のみとなります。</h3>
          </Col>
          <Col sm={12} className="margin-top-20 padding-left-right-clear">
            <Col sm={12} className="margin-top-10 padding-left-right-clear bold">
              言語設定
            </Col>
            <Col sm={2} className="margin-top-10 padding-left-right-clear">
              <RenderField
                type="selectbox"
                name="languageSetting"
                label="言語設定"
                data={SELECT_BOX_DATA.USERFRONT_LANGUAGE_SETTING_TYPE}
                handleChangeOption={this.handleChangeOption}
              />
            </Col>
          </Col>
          <Col sm={12} className="margin-top-20">
              <ThumbNail
                formValues={imageObject}
                handleImageFileChange={this.handleImageFileChange}
                onChangeCheckbox={this.onChangeCheckbox}
                isOEMUser={isOEMUser} // Step 10.3.0
              />
          </Col>
          <Col sm={12} className="margin-bottom-20 padding-left-right-clear">
            <Button
              variant="primary"
              className="btn-96 text-center margin-top-20"
              onClick={this.onOk}
              disabled={invalid || !isEnableRegistBtn || this.state.okBtnClick}
            >
              画像を登録
            </Button>
          </Col>
          <DialogConfirm
            showModal={this.state.showExportModal}
            mdSize={this.mdSize}
            content={MessageTemplate.MSG_USERFRONT_DISPLAY_SETTING_CONFIRM}
            onOK={this.onConfirmDialogOk}
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userfrontImage, authed: { authedUser: { isOEMUser } } } = state;
  const { initialData, imageObject, initialImageObject, languageSetting } = userfrontImage;
  const { userfrontImageLogin } = state.form;
  if (userfrontImageLogin && userfrontImageLogin.values) {
    if (userfrontImageLogin.values.languageSetting === undefined && languageSetting) {
      initialImageObject.languageSetting = languageSetting;
    }
  }
  const formValues = getFormValues('userfrontImageLogin')(state);
  const invalid = isInvalid('userfrontImageLogin')(state);
  let isEnableRegistBtn = false;

  if (formValues && Object.keys(formValues).length > 0 && imageObject && Object.keys(imageObject).length > 0) {
    LOGIN_SCREEN_KEY_LIST.map((childKey) => {
      const data = formValues[childKey];
      if (data) {
        const isManualFileSelection = data.imageUpdateType && data.imageUpdateType === INITIAL_IMAGE.IMAGE_SELECTION;
        imageObject[childKey].isManualFileUpload = data.isEnableFileUpload && isManualFileSelection;
        if (hasProperty(data, 'changed')) {
          imageObject[childKey].changed = data.changed;
          imageObject[childKey].imageUpdateType = data.imageUpdateType;
          isEnableRegistBtn =
            data.imageUpdateType === INITIAL_IMAGE.IMAGE_SYSTEMS ||
            (data.imageUpdateType === INITIAL_IMAGE.IMAGE_SELECTION &&
              hasProperty(data, "imageFileUpload") &&
              data.imageFileUpload !== "");
        }
      }
    });
  }

  return {
    initialData,
    initialValues: initialImageObject,
    formValues,
    invalid,
    imageObject,
    ...{ userfrontImageLogin },
    isEnableRegistBtn,
    isOEMUser, // Step 10.3.0
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'userfrontImageLogin', // a unique identifier for this form
    enableReinitialize: true,
  })(UserfrontLoginScreenContainer),
);
